// ICF Guide reducer
import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false, // ICF guide in home page loading
  error: false, // ICF guide error in home page
  icfList: [], // ICF guide response in home page
  query: '',
  isIcfSelected: false,
  icfArticleIsLoading: false, // paypal help guide L1 Topic Icf article loading
  icfArticleError: false, // paypal help guide L1 Topic Icf article error
  icfArticleList: [], // paypal help guide L1 Topic Icf article response
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ICF_CONTENTS:
      return {
        ...state,
        isLoading: true,
        error: false,
        icfList: [],
        query: action.payload,
      };
    case types.RECEIVED_ICF_CONTENTS:
      return {
        ...state,
        isLoading: false,
        error: false,
        icfList: action.payload,
      };
    case types.RECEIVED_ICF_CONTENTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        icfList: [],
      };
    case types.REQUEST_ARTICLE_ICF_CONTENTS:
      return {
        ...state,
        icfArticleIsLoading: true,
        icfArticleError: false,
        icfArticleList: [],
        icfArticleQuery: action.payload,
      };
    case types.RECEIVED_ARTICLE_ICF_CONTENTS:
      return {
        ...state,
        icfArticleIsLoading: false,
        icfArticleError: false,
        icfArticleList: action.payload,
      };
    case types.RECEIVED_ARTICLE_ICF_CONTENTS_ERROR:
      return {
        ...state,
        icfArticleIsLoading: false,
        icfArticleError: true,
        icfArticleList: [],
      };
    default:
      return state;
  }
}
